import { Policy } from 'api/types/policy';
import { authorizedAxios } from 'library/axios/apiProvider';

export async function getPolicy(id: string): Promise<Policy> {
  const { data } = await authorizedAxios().get(`/api/v1/policies-client/${id}/`);
  return data;
}
